import { AvailableModules, Features } from 'generated/featureDefinitions'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'
import { useCreateUpsellNotificationMessage } from 'modules/project_management/components/upsells/hooks/useCreateUpsellNotificationMessage'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface RequestUpgradeModalProps {
  onClose: () => void
  originProjects?: boolean
}

export const UpsellSalesInvoiceFeatureModal = ({
  onClose,
  originProjects = false,
}: RequestUpgradeModalProps) => {
  const { sendUpsellNotificationMessage } = useCreateUpsellNotificationMessage()
  const pageSource = originProjects ? 'projects_sales_invoices' : 'finance_sales_invoices'

  const onCloseUpsellModal = () => {
    track(trackingEvents.projectManagement.salesInvoices.upsellModal.cancelUpsellModal, {
      origin: originProjects ? 'Projects' : 'Invoices',
    })
    onClose()
  }

  const onSuccessNotify = async () => {
    track(trackingEvents.projectManagement.salesInvoices.upsellModal.confirmUpsellModal, {
      origin: originProjects ? 'Projects' : 'Invoices',
    })
    sendUpsellNotificationMessage(ProjectsUpsellRequestSources.projectSalesInvoices)
  }

  return (
    <UpsellingKit.ProductModal
      isOpen
      onClose={onCloseUpsellModal}
      onRequest={onSuccessNotify}
      requestSource={`Sales Invoice Feature Modal ${originProjects ? 'Projects' : 'Invoices'}`}
      featureRequested={Features.sales_invoices_creation}
      moduleRequested={AvailableModules.sales}
      requestReason={ValidReasons.MissingAddon}
      pageSource={pageSource}
    />
  )
}
